import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCbfOpBsfgOyeTCw2PxL-VHhe-Sl-dEfZQ",
    authDomain: "aim-trainer-75aeb.firebaseapp.com",
    projectId: "aim-trainer-75aeb",
    storageBucket: "aim-trainer-75aeb.appspot.com",
    messagingSenderId: "185884769145",
    appId: "1:185884769145:web:269963abacbdd99d404da8",
    measurementId: "G-G0YHQ9YJY5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
